import { slugifyRulebookId, uniqueRulebookDraftId } from "./rulebookDraftFactory";
import { listRulebookDrafts, saveRulebookDraft } from "./rulebookDraftStore";
import { apiRulebookPublishingClient } from "./rulebookPublishingClient";
import toPublishedRulebookSnapshot from "./toPublishedRulebookSnapshot";
/**
 * Pulls a server Rulebook the current owner has no draft for (saved from another browser, or whose link was lost)
 * into a new local draft linked to it, so the Editor's next Save updates that Rulebook rather than creating a copy.
 */
export default async function importPublishedRulebook({ rulebookId, client = apiRulebookPublishingClient, }) {
    const record = await client.getRulebook({ rulebookId });
    if (!record) {
        return { status: "missing" };
    }
    // Re-check after the fetch: another import of this Rulebook resolving meanwhile wins.
    const drafts = listRulebookDrafts();
    const linked = drafts.find((draft) => draft.rulebook_id === rulebookId);
    if (linked) {
        return { status: "imported", draftId: linked.definition.id };
    }
    const base = slugifyRulebookId(record.pending?.definition.name ?? record.live?.name ?? "") || "rulebook";
    const draftId = uniqueRulebookDraftId(drafts.map((draft) => draft.definition.id), base);
    const snapshot = toPublishedRulebookSnapshot({ record, draftId });
    if (!snapshot) {
        return { status: "missing" };
    }
    if (!saveRulebookDraft({ definition: snapshot.definition, meta: snapshot.meta, rulebookId })) {
        return { status: "storage_failed" };
    }
    return { status: "imported", draftId };
}
